import { fetchProjectLogs, changePage } from '#action/project/log';
import { ProjectsFilterOptionService, UserFilterOptionService, ActionTypeFilterOptionService } from '#service/autocomplete-service/service';
import { uuidv4 } from '#helper';
import { projectEventType } from '#type';

const projectComponent = {
  type: 'SelectWithCounter',
  name: 'project',
  label: 'Project',
  relatedTo: 'project-log',
  id: uuidv4(),
  fetchOptionsService: ProjectsFilterOptionService,
  searchFields: ['title']
};

const filterUserComponent = {
  type: 'SelectWithCounter',
  name: 'user',
  label: 'Actor',
  relatedTo: 'project-log',
  id: uuidv4(),
  fetchOptionsService: UserFilterOptionService,
  searchFields: ['fullName']
};

const actionTypeSelect = {
  type: 'SelectWithCounter',
  name: 'event',
  label: 'Action',
  relatedTo: 'project-log',
  id: uuidv4(),
  fetchOptionsService: ActionTypeFilterOptionService,
  optionServiceConfig: { eventTypes: projectEventType },
  searchFields: ['label']
};

const filterConfig = {
  disableSync: true,
  customActions: {
    fetchFilterData: fetchProjectLogs,
    changePage
  },
  dateRangeComponent: true,
  components: [projectComponent, filterUserComponent, actionTypeSelect]
};

export default filterConfig;
